import {MNullable} from '../../Toolkit/Utils';

export class AuditLog {
    public id: string = '';
    public parentId: string = '';
    public notes: string = '';
    public modifiedOn: MNullable<Date> = null;
    public modifiedBy: string ='';
};

export class AuditLogReply {
    public log: MNullable<AuditLog> = null;
};

export class AuditLogMultiReply {
    public logs: AuditLog[] = [];
};